import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import { ButtonGroup, Input } from '@/components/Forms'
import { LateTimeType, OfficialReportType } from '@/types/officialReport'
import { ButtonGroupOption } from '@/ui/Button'
import { OFFICIAL_REPORT_FORM_FIELDS } from '../../constant'
import { getLateReportTypeLabel } from '../../helpers/getLateReportTypeLabel'

import styles from '../OfficialReportModal.module.scss'

interface Props {
    reportType: OfficialReportType
}

const options: ButtonGroupOption[] = [
    {
        label: 'Scheduled',
        value: LateTimeType.Scheduled,
        variant: 'outline',
        size: 'small',
    },
    {
        label: 'Given',
        value: LateTimeType.Given,
        variant: 'outline',
        size: 'small',
    },
]

export const LateTime = ({ reportType }: Props) => {
    const { register, watch, trigger } = useFormContext()
    const timeType: LateTimeType | undefined = watch(OFFICIAL_REPORT_FORM_FIELDS.timeType)
    const takeoverTimeLabel = getLateReportTypeLabel(reportType, timeType)
    const actualTimeLabel =
        reportType === OfficialReportType.LateTakeover ? 'Actual takeover time' : 'Actual departure time'

    useEffect(() => {
        timeType && trigger(OFFICIAL_REPORT_FORM_FIELDS.timeType)
    }, [timeType])

    return (
        <>
            <ButtonGroup
                label="Time"
                className={styles.buttonGroup}
                options={options}
                {...register(OFFICIAL_REPORT_FORM_FIELDS.timeType)}
            />
            <div className={styles.fieldsRow}>
                <Input
                    fullWidth
                    label={takeoverTimeLabel}
                    placeholder="Time"
                    {...register(OFFICIAL_REPORT_FORM_FIELDS.takeoverTime)}
                />
                <Input
                    fullWidth
                    label={actualTimeLabel}
                    placeholder="Time"
                    {...register(OFFICIAL_REPORT_FORM_FIELDS.actualTakeoverTime)}
                />
            </div>
        </>
    )
}
